import React from 'react';
import PropTypes from 'prop-types';
import uniqBy from 'lodash.uniqby';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'day8-ui';
import {
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { capitalizeFirstLetter } from '../../../../helpers/utilities';
import { SiHarbor } from "@react-icons/all-files/si/SiHarbor";


const Marina = props => {
  const dispatch = useDispatch();
  const yachtsAvailable = useSelector(state => state.yachts.items);
  const { marina, destinationFilter } = getSelectedFilters(props.location);
  // only show relevant marinas based on selected destination (or all marinas)
  const marinasOptions = uniqBy(yachtsAvailable.filter(y => destinationFilter.length === 0 || destinationFilter.includes(`${y.week.destinationId}`)), 'marina.name').map(yacht => yacht.marina.name);
  const selectedFilterText = marina.map(item => capitalizeFirstLetter(item)).join(', ');
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Marina</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        {marinasOptions.map(item => (
          <Button key={JSON.stringify(item)} buttonType={isFilterSelected(props.location, FILTERS.MARINA, item) ? "FILTER_ACTIVE" : "FILTER"} onClick={() => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.MARINA, item)}>{item}</Button>
        ))}
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<SiHarbor />}>{selectedFilterText || 'Marina'}</Button>;
};
Marina.propTypes = {
  location: PropTypes.object.isRequired,
  setPage: PropTypes.func,
  filterAction: PropTypes.func.isRequired,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string
};
export default Marina;
